import {compact} from 'lodash-es'

const combineAddress = ({
  addressNumber,
  street,
  ward,
  district,
  province,
}) => compact([
  ((addressNumber || '') + (street ? ` ${street}` : '')).trim(),
  ward,
  district,
  province,
]).join(', ')

export default combineAddress
